module.exports = __webpack_public_path__ + "img/gb896.prt.8c9bcf62.jpg";